import React from 'react';
import { ViteReactSSG } from 'vite-react-ssg';
import type { RouteRecord } from 'vite-react-ssg';
import Layout from './Layout';
import {
  Home,
  AppShell,
  Dashboard,
  Pricing,
  Login,
  Register,
  AuthVerify,
  ForgotPassword,
  ResetPassword,
  VerifyEmail,
  ConfirmEmailChange,
  ProjectDetail,
  EndpointDetail,
  ShareView,
  Account,
  Billing,
  Privacy,
  Terms,
  InviteAccept,
  SettingsTeam,
  TeamDashboard,
} from './pages';

export const routes: RouteRecord[] = [
  {
    path: '/',
    element: <Layout />,
    entry: 'src/Layout.tsx',
    children: [
      { index: true, Component: Home },
      { path: 'pricing', Component: Pricing },
      { path: 'dashboard', Component: Dashboard },
      { path: 'login', Component: Login },
      { path: 'register', Component: Register },
      { path: 'auth/verify', Component: AuthVerify },
      { path: 'forgot-password', Component: ForgotPassword },
      { path: 'reset-password', Component: ResetPassword },
      { path: 'verify-email', Component: VerifyEmail },
      { path: 'confirm-email', Component: ConfirmEmailChange },
      { path: 'projects/:projectId', Component: ProjectDetail },
      { path: 'projects/:projectId/endpoints/:endpointId', Component: EndpointDetail },
      { path: 'share/:token', Component: ShareView },
      { path: 'account', Component: Account },
      { path: 'invite/:token', Component: InviteAccept },
      { path: 'teams/:teamId', Component: TeamDashboard },
      { path: 'teams/:teamId/settings', Component: SettingsTeam },
      { path: 'billing', Component: Billing },
      { path: 'privacy', Component: Privacy },
      { path: 'terms', Component: Terms },
      // Prerendered to dist/shell.html and used as the SPA fallback; not a
      // route users navigate to. See AppShell.tsx.
      { path: 'shell', Component: AppShell },
    ],
  },
];

export const createRoot = ViteReactSSG({ routes, basename: import.meta.env.BASE_URL });
